module.exports = __webpack_public_path__ + "static/img/02.2a583df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/280319/02.png
// module id = LjxX
// module chunks = 0